module.exports = __webpack_public_path__ + "static/media/social_telegram.d31e9c8f.svg";